module.exports = __webpack_public_path__ + "static/media/nextlook-logo.9dfc9c1c.svg";